module.exports = __webpack_public_path__ + "static/media/1-1.81e5df70.svg";